import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import InfoCard from './InfoCard';
import { request } from 'utilities/graph';
import { getTransaction } from 'graphql/queries';

export default function TransactionCard({ id, title = '交易資料', data: transactionId, ...props }) {
  const [data, setData] = useState();
  const [mappings, setMappings] = useState([]);

  useEffect(() => {
    const fetchTransaction = async () => {
      if (transactionId) {
        const { data: { getTransaction: data } } = await request(getTransaction, { id: transactionId });
        if (data.serviceProvider === 'newebpay (CREDIT)') {
          data.serviceProvider = '藍新金流 (信用卡)';
          // TODO: why need to parse twice?
          const newebPayResult = JSON.parse(JSON.parse(data.newebPayResult));
          console.log('newebPayResult', newebPayResult);
          Object.assign(data, newebPayResult);
          setMappings([
            { key: 'MerchantID', label: '商店代號' },
            { key: 'serviceProvider', label: '交易方式' },
            // { key: 'statusMessage', label: '交易狀態' },
            { key: 'PayTime', label: '支付完成時間' },
            { key: 'Amt', label: '訂單金額' },
            // { key: 'AuthBank', label: '授權銀行' },
            { key: 'Auth', label: '授權碼' },
            { key: 'TradeNo', label: '交易序號' },
            { key: 'MerchantOrderNo', label: '商店訂單編號' },
          ]);
        } else if (data.serviceProvider === 'linepay') {
          data.serviceProvider = 'LINE Pay';
          // TODO: why need to parse twice?
          const linePayInfo = JSON.parse(JSON.parse(data.linePayInfo));
          if (linePayInfo?.[0]) {
            Object.assign(data, linePayInfo[0]);
          }
          setMappings([
            { key: 'serviceProvider', label: '交易方式' },
            { key: 'linePayTransactionId', label: 'LINE Pay 交易編號' },
            { key: 'amount', label: '交易金額' },
          ]);
        }
        setData(data);
      }
    };

    fetchTransaction();
  }, [transactionId]);

  if (!data) return null;

  return (
    <InfoCard
      title={title}
      mappings={mappings}
      data={data}
      onUpdate={setData}
      {...props}
    />
  );
}

TransactionCard.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  data: PropTypes.string,
};
